<template>
<div class="wrap">
    <schoolAndDate :schoolName="schoolName" :dateTime="dateTime" />
    
    <div class="page_index">
        <div class="header-title">
            <div class="title-item">品名</div>
            <div class="title-item">
                <span class="sub-title">(换算获得)</span>
                <span>采购价</span>
            </div>
            <div class="title-item">指导价</div>
            <div class="title-item">比升降</div>
            <div class="title-item">供应商</div>
        </div>
        <div class="scroll_ist flex" :style="itemStyle">
            <div class="scoll_warp" :style="`animation-duration:${animationDuration}s`">
                <ul>
                    <li v-for="(item,index) in rankList" :key="index" :style="isLeft(index)">
                        <div class="flex flex_sb page_list">
                            <div class="page_name">{{item.name || item.productName || '暂无'}}</div>
                            <div class="page_price">
                                <div class="page_num">{{ renderPurchasePrice(item) }}</div>
                                <div class="page_unit">元/{{ item.unitName || item.unit || '' }}</div>
                            </div>
                            <div class="page_price zhidao">
                                <div class="page_num">{{ renderGuidePrice(item) }}</div>
                                <div class="page_unit" v-if="item.guidePrice">元/{{ item.unitName || item.unit || '' }}</div>
                            </div>
                            <div class="page_price">
                                <img class="page_img" :src="renderArrow(item.compareIncreaseDecrease || item.priceChange || '')" alt="">
                            </div>
                            <!-- 竖屏的公司显示 -->
                            <div class="page_title" style="flex-direction: column; flex: 0 0 24%;"> 
                                <div v-for="(name,iname) in supplierName(item.supplierName)" :key="iname">{{ name }}</div>
                            </div> 
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>


</div>
</template>

<script>
    import {
        fontVh
    } from "@/assets/js/common";
    import schoolAndDate from "./schoolAndDate.vue";

    export default {
        name: 'articleList',
        props: { 
            schoolName: {
                type: String,
                default: '',
            },
            dateTime: {
                type: String,
                default: '',
            },
            rankList: {
                type: Array,
                default: () => []
            },
            unit: {
                type: String,
                default: ''
            },
            uniIdx: {
                type: [Number, String],
                default: 1
            },
            // 用于改变数组列表单独一列文字靠左对齐
            active: {
                type: Number,
                default: -1
            },
            scrollHeight: {
                type: String,
                default: ''
            },
            speed: {
                type: Number,
                default: 0.3
            }
        },
        data() {
            return {
                iconArrUp: require("@/assets/images/icon_arrow_up.png"),
                iconArrDown: require("@/assets/images/icon_arrow_down.png"),
                iconArrNot: require("@/assets/images/icon_arrow_not.png"),
            }
        },
        components: { schoolAndDate },
        created() {},
        computed: {
            supplierName() {
                return function(name) {
                    if (!name) return ['暂无']
                    let arr = [];
                    let index = 0;
                    while (index < name.length) {
                        arr.push(name.slice(index, index += 6));
                    }
                    return arr
                }
            },
            animationDuration() {
                if (this.rankList.length >= 11) {
                    return this.rankList.length * 2.5
                }
                return 0
            },
            itemStyle() {
                const {
                    scrollHeight
                } = this
                return `height:${fontVh(scrollHeight)};`
            },
            isLeft() {
                return (idx) => {
                    return `text-align:${this.active != idx ? 'center' : 'left'};`
                }
            }
        },
        watch: {},
        methods: {
            // 渲染采购价
            renderPurchasePrice(item) {
                // const priceTxt = item.price || item.purchasePrice || ''
                // const renderPrice = (Number(priceTxt) >= 0) ? Number(priceTxt).toFixed(2) : priceTxt
                // return renderPrice
                return (item.price || item.purchasePrice || 0)
            },
            // 渲染指导价
            renderGuidePrice(item) {
                // const priceTxt = item.guidePrice || ''
                // const renderPrice = (Number(priceTxt) >= 0) ? Number(priceTxt).toFixed(2) : priceTxt
                // return renderPrice
                return item.guidePrice
            },
            // 渲染比升降箭头
            renderArrow(value) {
                if (value === 'gt') {
                    return this.iconArrUp
                }
                if (value === 'lt') {
                    return this.iconArrDown
                }
                return this.iconArrNot
            },
        }
    }
</script>

<style lang='scss' scoped>
    @keyframes scroll-up {
        0% {
            transform: translateY(0);
            /* 文本初始位置，向上偏移 0 */
        }

        100% {
            transform: translateY(-100%);
            /* 文本最终位置，向上偏移 100%（等于滚动区域高度） */
        }
    }

    $textColor: #2E670B;
    .wrap {
        position: relative;
    }

    .page_index {
        word-break: break-all;
        overflow: hidden;
        // padding: 0 vh(20);
        display: flex;
        justify-content: center;
        position: relative;
        background: radial-gradient( 0% 0% at 0% 0%, #BAECCA 0%, #ECEDA2 0%);
        border-radius: 6px 6px 6px 6px;

        

        .header-title {
            position: absolute;
            z-index: 6;
            width: 100%;
            display: flex;
            font-size: vh(20);
            font-weight: bold;
            color: $textColor;
            padding: vh(30) vh(25) vh(10);
            background: radial-gradient( 0% 0% at 0% 0%, #BAECCA 0%, #ECEDA2 0%);
            .title-item:nth-of-type(1) {
                width: 55%;
                text-align: left;
            }
            .title-item:nth-of-type(2) {
                width: 44%;
                text-align: left;
                position: relative;
                .sub-title {
                    display: block;
                    font-size: vh(10);
                    position: absolute;
                    left: vh(7);
                    top: 0;
                    transform: translateY(-100%);
                }
            }
            .title-item:nth-of-type(3) {
                width: 45%;
                text-align: left;
            }
            .title-item:nth-of-type(4) {
                width: 11%;
            }
            .title-item:nth-of-type(5) {
                width: 66%;
            }
        }

        .scroll_ist {
            overflow: hidden;
            width: 100%!important;
            padding-top: vh(60);

            &.flex {
                align-items: flex-start;
            }

            .scroll_header {
                margin: vh(8) 0 vh(14) 0;
                @include flex();
                @include font(16, $list_color, center);

                >div {
                    position: relative;
                    padding: 0 vh(10);
                }
            }

            .scoll_warp {
                overflow: hidden;
                animation-name: scroll-up;
                animation-duration: 0;
                animation-timing-function: linear;
                animation-iteration-count: infinite;

                /* 动画名称、持续时间、缓动函数和重复次数 */
                ul {
                    li {
                        span {
                            padding: 0 vh(10);
                            word-break: break-all;
                        }

                        div {
                            text-align: left;
                            justify-content: space-between;
                        }

                        .page_border {
                            margin: 0 vh(10);
                            border: vh(1) dashed #27c5ff;
                        }

                        .page_list {
                            padding: vh(10) vh(25);
                            text-align: center;
                            border-bottom: 1px solid #96C59D;

                            .page_name {
                                width: 20%;
                                @include font(24-3, $textColor);
                                font-weight: bold;
                            }

                            .page_price {
                                @include font(20-3, #106BC0, center);
                                width: 20%;

                                .page_num {
                                    @include font(24, #106BC0, center);
                                    font-weight: bold;
                                }
                                .page_unit {
                                    text-align: center;
                                    color: $textColor;
                                }

                                &.hide {
                                    visibility: hidden;
                                }
                            }

                            .page_img {
                                width: vh(14);
                            }

                            .page_title {
                                width: 40%;
                                display: flex;
                                @include font(22-3, $textColor);
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
        }
    }
</style>